import * as React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import PhotoWithFlag from "./PhotoWithFlag";
import DriverStatistic from "../DriverStatisic";
import { Plug } from "../Icons";
const useStyles = makeStyles(({
  palette,
  breakpoints,
  typography
}) => ({
  container: {
    display: "flex",
    position: "relative",
    alignItems: "center",
    [breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  },
  namePronunciation: {
    fontSize: "0.875rem"
  },
  driverBaseInfoItem: {
    [breakpoints.up("md")]: {
      "&+&": {
        marginLeft: "2.5rem"
      }
    },
    [breakpoints.down("sm")]: {
      "&+&": {
        marginTop: "1.5625rem"
      }
    }
  },
  driverNameAndStatistic: {
    display: "flex",
    alignItems: "center",
    [breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  },
  driverNameContainer: {
    [breakpoints.down("sm")]: {
      display: "flex",
      alignItems: "center",
      flexDirection: "column"
    }
  },
  driverName: {
    fontSize: "1.4em",
    color: palette.text.headline,
    [breakpoints.down("sm")]: {
      position: "relative",
      marginTop: typography.pxToRem(-15)
    }
  },
  vehicleType: {
    position: "absolute",
    bottom: -18,
    color: palette.text.highlightSuccess,
    fontSize: "1rem",
    [breakpoints.down("sm")]: {
      marginTop: "1.5625rem",
      position: "static",
      bottom: "auto"
    }
  },
  electricIcon: {
    transform: "rotate(180deg)",
    position: "absolute",
    right: `calc(100% + ${typography.pxToRem(5)})`,
    top: "-50%"
  }
}));
export default (({
  driver,
  driverName,
  photo,
  isVehicleElectric,
  showDriverBaseInfo
}) => {
  const styles = useStyles();
  const {
    namePronunciation,
    deliveriesScore,
    countryCode,
    rating,
    serviceScore
  } = driver;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.driverBaseInfoItem
  }, /*#__PURE__*/React.createElement(PhotoWithFlag, {
    country: countryCode,
    photo: photo,
    isVehicleElectric: isVehicleElectric
  })), /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.driverNameAndStatistic, styles.driverBaseInfoItem)
  }, showDriverBaseInfo && /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.driverBaseInfoItem, styles.driverNameContainer)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.driverName
  }, isVehicleElectric && window.matchMedia("(max-width: 960px)").matches && /*#__PURE__*/React.createElement(Plug, {
    className: styles.electricIcon,
    style: {
      width: "53px",
      height: "26px"
    }
  }), driverName), !!namePronunciation && /*#__PURE__*/React.createElement("div", {
    className: styles.namePronunciation
  }, "(", namePronunciation, ")")), /*#__PURE__*/React.createElement(DriverStatistic, {
    deliveries: deliveriesScore,
    rating: rating,
    years: serviceScore,
    className: styles.driverBaseInfoItem
  }), isVehicleElectric && /*#__PURE__*/React.createElement("div", {
    className: styles.vehicleType
  }, "Proudly delivering in an all-electric vehicle")));
});